module.exports = __webpack_public_path__ + "img/fashion.c94fba4a.jpg";